import { render } from "./OrderApproved.vue?vue&type=template&id=f9348d7a&scoped=true"
import script from "./OrderApproved.vue?vue&type=script&lang=js"
export * from "./OrderApproved.vue?vue&type=script&lang=js"

import "./OrderApproved.vue?vue&type=style&index=0&id=f9348d7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9348d7a"]])

export default __exports__